import { Worksheet } from "exceljs";
import { JsonSchema } from "../../../../types";
import { getExportSchemaTitles } from "../schemaHelpers";
import { autoFitColumns, styleHeader } from "../export/worksheetBuilder";

export const formatAndProtectWorksheet = async (
  worksheet: Worksheet,
  headers: string[],
  schema: JsonSchema,
): Promise<void> => {
  formatWorksheet(worksheet);
  unlockAllCells(worksheet);
  lockColumns(worksheet, getReadOnlyColumns(headers, schema));
  lockHeaderRow(worksheet);

  await worksheet.protect("", {
    selectLockedCells: true,
    selectUnlockedCells: true,
    insertRows: true,
    deleteRows: true,
    formatRows: true,
    formatCells: true,
  });
};

export const formatWorksheet = (worksheet: Worksheet): void => {
  styleHeader(worksheet);
  autoFitColumns(worksheet);
};

const unlockAllCells = (worksheet: Worksheet) => {
  worksheet.eachRow((row) => {
    row.eachCell({ includeEmpty: true }, (cell) => {
      cell.protection = {
        locked: false,
      };
    });
  });
};

const lockColumns = (worksheet: Worksheet, columnIndexes: number[]) => {
  columnIndexes.forEach((columnIndex) => {
    worksheet.getColumn(columnIndex).eachCell((cell) => {
      cell.protection = { locked: true };
    });
  });
};

const lockHeaderRow = (worksheet: Worksheet) => {
  worksheet.getRow(1).eachCell((cell) => {
    cell.protection = { locked: true };
  });
};

const getReadOnlyColumns = (
  headers: string[],
  schema: JsonSchema,
): number[] => {
  const readOnlyTitles = new Set(
    Object.values(getExportSchemaTitles(schema)).filter((title) =>
      title.endsWith("_READ_ONLY"),
    ),
  );
  return headers.flatMap((header, index) =>
    readOnlyTitles.has(header) ? [index + 1] : [],
  );
};
